export default {
  filterData : {
  Products: {
    label: 'Produits',
    allFilterLabel: "Tous les produits",
    items: [
      { name: "Citrix ADC", id: "citrix_adc" },
      { name: "Citrix Analytics for Performance", id: "citrix_analytics_for_performance" },
      { name: "Citrix Analytics for Security", id: "citrix_analytics_for_security" },     
      { name: "Citrix App Delivery and Security Service", id:"citrix_app_delivery_and_security_service"},
      { name: "Citrix Application Delivery Management", id: "citrix_application_delivery_management" },
      { name: "Citrix Content Collaboration", id: "citrix_content_collaboration" },
      { name: "Citrix DaaS (formerly Citrix Virtual Apps and Desktops service)", id: "citrix_virtual_apps_and_desktops" },
      {
        name: "Citrix DaaS Standard for Azure",
        id: "citrix_virtual_apps_and_desktops_standard_for_azure"
      },
      {
        name: "Citrix DaaS Standard for Google Cloud",
        id: "citrix_daas_standard_for_google_cloud",
      },
      { name: "Citrix Endpoint Management", id: "citrix_endpoint_management" },
      { name: "Citrix Gateway", id: "citrix_gateway" },
      { name: "Citrix SD-WAN", id: "citrix_sd_wan" },
      { name: "Citrix Secure Internet Access", id: "citrix_secure_internet_access" },
      { name: "Citrix Secure Private Access", id: "citrix_secure_private_access" },
      { name: "Citrix Virtual Apps and Desktops", id: "citrix_virtual_apps_desktops" },
      { name: "Citrix Web App and API Protection", id: "citrix_web_app_and_api_protection" },
      { name: "Citrix Workspace", id: "citrix_workspace" },
    ],
  },
  Topics: {
    label: "Sujets",
    allFilterLabel: "Tous les sujets",
    items: [
      { name: "Gestion de l’accès", id: "Access management" },
      { name: "Analytique et surveillance", id: "Analytics and monitoring" },
      { name: "Mise à disposition et sécurité des applications", id: "Application delivery and security" },
      { name: "Citrix et Google", id: "Citrix and Google" },
      { name: "Citrix et Microsoft", id: "Citrix and Microsoft" },
      { name: "Migration vers le cloud", id: "Cloud migration" },
      { name: "Comparer", id: "Compare" },
      { name: "Collaboration de contenu", id: "Content collaboration" },
      { name: "Espaces de travail digitaux", id: "Digital workspaces" },
      { name: "Expérience collaborateur", id: "Employee experience" },
      { name: "Cloud hybride", id: "Hybrid cloud" },
      { name: "Travail hybride", id: "Hybrid work" },
      { name: "Gérer et optimiser", id: "Manage and optimize" },
      { name: "Microservices et devOps", id: "Microservices and devOps" },
      { name: "Intégration et adoption", id: "Onboarding and adoption" },
      { name: "Intégrations partenaires", id: "Partner integrations" },
      { name: "Fiche produit", id: "Product overview" },
      { name: "Sécurité et conformité", id: "Security and compliance" },
      { name: "Petites entreprises", id: "Small business" },
      { name: "Spécifications", id: "Specifications" },
      { name: "Durabilité", id: "Sustainability" },
      { name: "Gestion unifiée des points de terminaison", id: "Unified endpoint management" },
      { name: "VDI et DaaS", id: "VDI and DaaS" },
    ],
  }, 
  Type: {
    label: 'Type',
    allFilterLabel: "Tous types",
    items: [
      { name: "Rapport d'analyse", id: "Analyst report" },
      { name: "Outil d’évaluation", id: "Assessment tool" },
      { name: "Témoignage client", id: "Customer story" },
      { name: "Fiche technique", id: "Data sheet" },
      { name: "Démo", id: "Demo" },
      { name: "eBook", id: "eBook" },
      { name: "Guide", id: "Guide" },
      { name: "Infographie", id: "Infographic" },
      { name: "Visite interactive", id: "Interactive tour" },
      { name: "Podcast", id: "Podcast" },
      { name: "Kit de ressources", id: "Resource kit" },
      { name: "Brief solution", id: "Solution brief" },
      { name: "Brief technique", id: "Technical brief" },
      { name: "Vidéo", id: "Video" },
      { name: "Webinaire", id: "Webinar" },
      { name: "Livre blanc", id: "White paper" },
    ],
  },
  Industry: {
    label: "Secteur",
    allFilterLabel: "Tous les secteurs",
    items: [
      { name: "Enseignement", id: "education" },
      { name: "Services financiers", id: "financial_service" },
      { name: "Secteur public", id: "government" },
      { name: "Santé", id: "healthcare" },
      { name: "Industrie", id: "manufacturing" },
      { name: "Commerce de détail", id: "retail" }
    ],
  }
  },
  searchPlaceholder: "Parcourir la bibliothèque",
  titles : {
    label1: "En vedette",
    label2: "Dernières ressources",
    label3: "Vu récemment",
    label4: "Ressources recommandées"
  },
  showMoreLabel: "Afficher plus",
  clearAllSelected: "Supprimer la sélection",
  searchResults: "Résultats de la recherche pour",
  clearAllFilters: "Supprimer tous les filtres",
  noResultsFound: "Aucun actif ne répond aux critères que vous avez sélectionnés",
  resetView: "Réinitialiser l’affichage",
  filterLabel: "Filtrer",
  filteredRes: "Résultats filtrés",
  filterRes: "Filtrer vos résultats",
  clearAllCta: "Tout supprimer",
  applyCta: "Postulez",
  view: "Afficher",
  includeEnglishRes: "Inclure les ressources en anglais"
};
